import { apiClient } from "@/lib/api-client"
import {
  FolderPermissionDto,
  GrantFolderPermissionRequest,
} from "../dtos/FolderPermissionDto"
import { BulkShareRequest, BulkShareResult } from "../dtos/BulkPermissionDtos"

export const folderPermissionService = {
  getFolderPermissions: async (
    organizationId: string,
    folderId: string,
  ): Promise<FolderPermissionDto[]> => {
    const response = await apiClient.get<FolderPermissionDto[]>(
      `/organizations/${organizationId}/document-folders/${folderId}/permissions`,
    )
    return response.data
  },

  grantFolderPermission: async (
    organizationId: string,
    folderId: string,
    request: GrantFolderPermissionRequest,
  ): Promise<FolderPermissionDto> => {
    const response = await apiClient.post<FolderPermissionDto>(
      `/organizations/${organizationId}/document-folders/${folderId}/permissions`,
      request,
    )
    return response.data
  },

  revokeFolderPermission: async (
    organizationId: string,
    permissionId: string,
  ): Promise<void> => {
    await apiClient.delete(
      `/organizations/${organizationId}/document-folders/permissions/${permissionId}`,
    )
  },

  bulkGrantFolderPermissions: async (
    organizationId: string,
    folderId: string,
    request: BulkShareRequest,
  ): Promise<BulkShareResult> => {
    const response = await apiClient.post<BulkShareResult>(
      `/organizations/${organizationId}/document-folders/${folderId}/permissions/bulk`,
      request,
    )
    return response.data
  },
}
